/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-restricted-imports
import { ApolloError } from '@apollo/client';
// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_DirectoryController_GetRecords_SchemaName,
  QueryInput_DirectoryController_GetRecords_Status,
  useDirectoryGetRecordsQuery,
} from 'api/generated/graphql';
import { parseDirectoryRecordData, useError } from 'api/helpers';
import { ListData, ListDataQueryFunction } from 'api/types/data';
import { DirectoryRecordData } from 'api/types/data/directory/directory';
import { lodash } from 'helpers';

export const useDirectoryGetRecords: ListDataQueryFunction<
  DirectoryRecordData,
  {
    search?: string;
  },
  '',
  { onlyIsActive?: boolean; directorySchemaName: string; fields?: string },
  { serverError: ApolloError | undefined }
> = ({ pagination, filter, params }) => {
  const {
    loading,
    error: serverError,
    data,
  } = useDirectoryGetRecordsQuery({
    variables: {
      limit: pagination.limit,
      page: pagination.page + 1,
      schemaName:
        params?.directorySchemaName as QueryInput_DirectoryController_GetRecords_SchemaName,
      search: filter?.search || undefined,
      status: params?.onlyIsActive
        ? QueryInput_DirectoryController_GetRecords_Status.Active
        : undefined,
      fields: params?.fields,
    },
  });

  const error = useError(serverError);

  const listData: ListData<DirectoryRecordData> | undefined =
    data?.directoryRecords
      ? {
          total: data?.directoryRecords?.total,
          list: lodash
            .compact(data?.directoryRecords?.list)
            .map(parseDirectoryRecordData),
        }
      : undefined;

  return {
    listData,
    loading,
    error,
    serverError,
  };
};
